export enum ContextMenuItems {
  SORT = 'sort',
  EXPLAIN = 'explain',
  MAXIMIZE = 'maximize',
  MANAGE_COLUMNS = 'manageColumns',
  INCLUDE_MISSING = 'includeMissing',
}
